export default function reorderFields(content) {
  //School
  let tempSchool = {};
  tempSchool.schooljaar = content.school.schooljaar;
  tempSchool.brincode = content.school.brincode;
  tempSchool.dependancecode = content.school.dependancecode;
  tempSchool.aanmaakdatum = content.school.aanmaakdatum;
  tempSchool.xsdversie = "2.3";
  content.school = tempSchool;

  //Groups
  let groupsToRemove = [];

  content.groepen.groep.forEach((group, i) => {
    let tempGroup = {};
    tempGroup.key = group.key;
    tempGroup.naam = group.naam;
    tempGroup.jaargroep = group.jaargroep;
    tempGroup.omschrijving = group.omschrijving;
    groupsToRemove.push(i);
    content.groepen.groep.push(tempGroup);
  });

  groupsToRemove.forEach((i) => {
    delete content.groepen.groep[i];
  });

  //Pupils
  let pupilsToRemove = [];
  content.leerlingen.leerling.forEach((pupil, i) => {
    let tempPupil = {};
    tempPupil.key = pupil.key;
    tempPupil.achternaam = pupil.achternaam || null;
    tempPupil.voorvoegsel = pupil.voorvoegsel || null;
    tempPupil.voornamen = pupil.voornamen || null;
    tempPupil["voorletters-1"] = pupil["voorletters-1"] || null;
    tempPupil.roepnaam = pupil.roepnaam || null;
    tempPupil.geboortedatum = pupil.geboortedatum || null;
    tempPupil.geslacht = pupil.geslacht || null;
    tempPupil.start_ondw_jgr3 = pupil.start_ondw_jgr3 || null;
    tempPupil.jaargroep = pupil.jaargroep !== undefined && pupil.jaargroep !== null ? pupil.jaargroep : null;
    tempPupil.groep = pupil.groep || null;
    tempPupil.samengestelde_groepen = pupil.samengestelde_groepen || null;
    tempPupil.vestiging = pupil.vestiging || null;
    tempPupil.gebruikersnaam = pupil.gebruikersnaam || null;
    tempPupil.emailadres = pupil.emailadres || null;
    tempPupil.fotourl = pupil.fotourl || null;
    tempPupil.toevoegingen = pupil.toevoegingen || null;
    tempPupil.mutatiedatum = pupil.mutatiedatum || null;
    pupilsToRemove.push(i);
    content.leerlingen.leerling.push(tempPupil);
  });

  pupilsToRemove.forEach((i) => {
    delete content.leerlingen.leerling[i];
  });

  //Teachers
  let teachersToRemove = [];
  content.leerkrachten.leerkracht.forEach((teacher, i) => {
    let tempTeacher = {};
    tempTeacher.key = teacher.key || null;
    tempTeacher.achternaam = teacher.achternaam || null;
    tempTeacher.voorvoegsel = teacher.voorvoegsel || null;
    tempTeacher.voornamen = teacher.voornamen || null;
    tempTeacher["voorletters-1"] = teacher["voorletters-1"] || null;
    tempTeacher.roepnaam = teacher.roepnaam || null;
    tempTeacher.gebruikersnaam = teacher.gebruikersnaam || null;
    tempTeacher.emailadres = teacher.emailadres || null;
    tempTeacher.groepen = teacher.groepen || null;
    tempTeacher.samengestelde_groepen = teacher.samengestelde_groepen || null;
    tempTeacher.toevoegingen = teacher.toevoegingen || null;
    tempTeacher.mutatiedatum = teacher.mutatiedatum || null;
    teachersToRemove.push(i);
    content.leerkrachten.leerkracht.push(tempTeacher);
  });

  teachersToRemove.forEach((i) => {
    delete content.leerkrachten.leerkracht[i];
  });

  //remove empty keys from object
  cleanObject(content);

  return content;
}

const cleanObject = (object) => {
  Object.entries(object).forEach(([k, v]) => {
    if (v && typeof v === "object") cleanObject(v);
    if ((v && typeof v === "object" && !Object.keys(v).length) || v === null || v === undefined || v.length === 0) {
      if (Array.isArray(object)) object.splice(k, 1);
      else if (!(v instanceof Date)) delete object[k];
    }
  });
  return object;
};
